export default {
	profile: {
		name: 'Account',

		icon: 'far fa-user-circle',

		user: 'User',

		user_name: 'Username',

		account: 'Account',

		administration: '@:common.administration',

		privacy: 'Privacy', // collections/users

		tos: 'Terms of Service', // collections/users/tos

		last_login: 'Last login',

		last_data_update: 'Last data update',

		lost_password: 'Forgot Password', // routes/lostPassword

		change_password: 'Change Password',

		my_accounts: 'My Accounts',

		my_accounts_empty: 'No accounts linked.',

		my_accounts_error: 'Accounts could not be loaded.',

		my_accounts_no_building: 'No building assigned',

		my_accounts_no_unit: 'Accounts without a unit',

		my_accounts_contact: 'Contact',

		my_accounts_no_journals: 'No journal entries.',

		my_accounts_journals_error: 'Journal entries could not be loaded.',

		my_accounts_no_results: 'No accounts match the filters.',

		my_accounts_filter_building: 'Building',

		my_accounts_filter_unit: 'Unit',

		balance: 'Balance',

		password: 'Password', // Validate/names

		reset_password: 'Reset Password', // routes/resetPassword

		confirmation: 'Password Confirmation', // validate/names

		personal_data_update: 'Update Personal Data',

		delete_profile_picture: 'Delete Profile Photo',

		send_messages: 'Sent Messages',

		email_registered_multiple_notice:
			'Your email address is registered with multiple administrations.\n' +
			'You can switch data using the selection below.',

		explanation:
			'Please select here which types of documents or ' +
			'information you would like to receive notifications about via email. ' +
			'Notifications will only be sent to your registered email address.',

		warning:
			'Please note that despite your selected preferences, ' +
			'you may still receive notifications about urgent information.',

		switch: {
			propertyDocs: 'Documents related to your property/properties',
			unitDocs: 'Documents related to your unit(s)',
			personDocs: 'Personal documents',
			notes: 'Notes',
			consumption:
				'@:component.consumption.consumptionInformation / Meter readings',
			reports: 'Information about reports',
		},

		updateRequest: {
			title: 'Update Personal Information',
			birthday: 'Birthday',
			reset: '@:common.reset',
			duplicateWarning:
				'A request already exists. Until it has been processed, ' +
				'no new request can be started. You can delete the existing one ' +
				'and start a new request',
			sent: 'Your request has been sent.',
			discardConfirm: 'Do you really want to discard the application?',
			emailTooltip:
				'The email address currently used for login cannot be changed. ' +
				'If this email address needs to be changed, please add an instruction in the comment field.',
			pendingInfo:
				'There is already a pending update request for this person. ' +
				'Submitting this form will overwrite the previous request.',
		},
	},
}
